// Overhead power line clearance: the minimum distance a load or crane must keep from an energized line
// (OSHA 1926.1408 Table A, by nominal voltage). The crossing's clearance is line height minus the tallest load.
const TABLE_A: [number, number][] = [[50, 10], [200, 15], [350, 20], [500, 25], [750, 35], [1000, 45]];
/** Minimum clearance in feet for a line of `kv` kilovolts. */
export function clearanceFor(kv: number): number {
  for (const [max, ft] of TABLE_A) if (kv <= max) return ft;
  return 45 + Math.ceil((kv - 1000) / 100) * 2;
}

/** How a crane gets from one turbine to the next, with the default days it takes and its map colour. One table for
 *  the crane sequence (Site Operations), the waterfall and the walk map. */
export const CRANE_MOVES: Record<string, { label: string; days: number; color: string }> = {
  walk: { label: 'Walk', days: 0, color: '#2b59c3' }, partial_breakdown: { label: 'Partial breakdown', days: 2, color: '#d4880f' },
  full_breakdown: { label: 'Full breakdown', days: 4, color: '#b3261e' }, tear_down: { label: 'Tear down & move', days: 5, color: '#7b1a14' }, truck: { label: 'Truck (assembled)', days: 3, color: '#6b4fa0' },
};
export const MOVE_DAYS: Record<string, number> = Object.fromEntries(Object.entries(CRANE_MOVES).map(([k, v]) => [k, v.days]));
